<script>
export default {
  name: "ModalStats",
  delimiters: ["[[", "]]"],
  props: {
    chars: Array,
    showStats: Boolean,
  },
  template:`
    <div class="stats-modal active">
    <div class="stats-modal__header">
      <div class="stats-modal__close" v-on:click="closeModal">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.29419 6L12.0001 6" stroke="#2B1B35" stroke-width="1.75" stroke-miterlimit="10"/>
          <path d="M7.47066 1.625L2.29419 6.06872L2.30753 6.08017L7.31056 10.375" stroke="#2B1B35" stroke-width="1.75"
                stroke-miterlimit="10"/>
        </svg>
      </div>
      <div class="stats-modal__heading">Характеристики</div>
    </div>
    <div class="stats-modal__body cont">
      <div class="stats-modal__list">
        <div class="stats-modal__item" v-for="char in chars">
          <div class="stats-modal__title">[[ char.name ]]</div>
          <div class="stats-modal__val">[[ char.value ]]</div>
        </div>
      </div>
    </div>
  </div>
  `,
  data: () => ({
      showClass: 'stats-modal cont active',
  }),
  methods: {
    closeModal: function () {
      this.$emit("hideStats");
    },
  },
}
</script>

<style scoped>

</style>